export const SET_ACCOUNT = "SET_ACCOUNT";

export function setAccount(payload) {
  return {
    type: SET_ACCOUNT,
    payload
  };
}
